import React from 'react'
import './Counterstyle.css'
import CountUp from 'react-countup';
import Colimg from '../../assets/image-1.png'



export const Counterstyle = () => {
  return (
    <div class="counter-section">
        <div class="container">
        <div class="row row-rev">
            <div class="col-lg-12 align-self-center mb-3">
                <div class="bg-3 dark-background-2 p-5">
            <div class="row">
                <div class="col-lg-12">
                        <div class="count-box">
                        <div class="d-flex justify-content-between">
                            <div class="box">
                            <CountUp end={12} suffix="+" duration={5} 
                            enableScrollSpy 
                            scrollSpyOnce={true} />
                            <h5>Years of Excellence</h5>
                            </div>
                            <div class="box">
                            <CountUp end={6} suffix="k  +" duration={5} 
                            enableScrollSpy 
                            scrollSpyOnce={true} />
                            <h5>Student Placed</h5>
                            </div>
                            <div class="box">
                            <CountUp end={30} suffix="+" duration={5} 
                            enableScrollSpy 
                            scrollSpyOnce={true} />
                            <h5>Trainers</h5>
                            </div>
                            <div class="box">
                            <CountUp end={8} suffix="k +" duration={5} 
                            enableScrollSpy 
                            scrollSpyOnce={true} />
                            <h5>Students enrolled</h5>
                            </div>
                            <div class="box">
                            <CountUp end={400} suffix="+" duration={5} 
                            enableScrollSpy 
                            scrollSpyOnce={true} />
                            <h5>Batches Complete</h5>
                            </div>
                        </div>
                        </div>
                </div>
            </div>
            </div>
            </div>
        
        </div>
        </div>
    </div>
  )
}
